import type { BondRequest } from "@portal/api/bond-request/agent";
import type { UseFollowersReturn } from "@portal/api/followers";
import { useFetchAgentPreviews } from "@portal/api/user/agent";
import { FollowerControls } from "@portal/components/ui/FollowerControls";
import { getStatusCardByStatus } from "@portal/components/ui/StatusCard";
import { TruncatedLabel } from "@portal/components/ui/TruncatedLabel";
import type { FC } from "react";
import { formatDisplayTitle } from "../../../utils";

export type AgentBondRequestStickyPanelProps = {
	request: BondRequest;
	followersControl: UseFollowersReturn;
};

export const AgentBondRequestStickyPanel: FC<AgentBondRequestStickyPanelProps> = ({
	request,
	followersControl,
}) => {
	return (
		<div
			data-testid="agent-bond-request-sticky-panel"
			className="flex items-center gap-3 whitespace-nowrap"
		>
			<TruncatedLabel
				label={`${formatDisplayTitle(request.displayTitle)} · ${request.principal.name}`}
				className="hidden max-w-[240px] text-[12px] font-[550] text-secondary lg:block"
			/>
			{getStatusCardByStatus(request.status, "", { iconOnly: true })}
			<FollowerControls
				{...followersControl}
				useFetchAgentPreviews={useFetchAgentPreviews}
				notFollowingLabel="Follow this request"
				trackingId="bond-request-agent-follow-sticky"
				manageFollowersSubtext="Followers will receive email notifications for all comments and changes to the status of this bond request"
				hideFollowerCount
				condensed
			/>
		</div>
	);
};
